export const USER_IDS = {
  mapsUnauthorized: 'maps-unauthorized',
  mapsFrameUnauthorized: 'maps-frame-unauthorized',
  mapsClient: 'maps-client',
  mapsRegional: 'maps-regional',
  mapsRegionalMimicClient: 'maps-regional-mimic-client',
  mapsAgentMimicClient: 'maps-agent-mimic-client',
} as const;
